import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.string.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { toNumber } from 'lodash';
import { ReportType,
// useGetDisclosureSummaryQuery,
useGetFundQuery, useGetSectionWithQuestionsQuery } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ResultsView',
  props: {
    reportType: {
      type: String,
      required: true,
      validator: function validator(value) {
        return Object.values(ReportType).includes(value);
      },
      default: ReportType.SfdrFundWebsiteDisclosure
    },
    sectionId: {
      type: Number,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var route = useRoute();
    var _useGetFundQuery = useGetFundQuery({
        id: toNumber(route.params.fund)
      }),
      result = _useGetFundQuery.result;
    var fund = computed(function () {
      var _result$value;
      return (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getFund;
    });

    // we're currently restricting usage of openai, might be enabled at a later date
    // const { result: disclosureSummaryResult, loading: summaryLoading } =
    //   useGetDisclosureSummaryQuery({
    //     fundId: toNumber(route.params.fund),
    //     referencePeriod: props?.currentReferencePeriod,
    //     reportType: props.reportType as ReportType,
    //   })

    // const disclosureSummary = computed(() => {
    //   return disclosureSummaryResult.value?.getDisclosureSummary?.summary
    // })

    var _useGetSectionWithQue = useGetSectionWithQuestionsQuery(computed(function () {
        var input = {
          id: props.sectionId,
          fundId: toNumber(route.params.fund),
          referencePeriodId: toNumber(route.query.referencePeriodId)
        };
        return input;
      }), computed(function () {
        var _route$query;
        return {
          enabled: !!((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.referencePeriodId)
        };
      })),
      sectionResult = _useGetSectionWithQue.result,
      getSectionLoading = _useGetSectionWithQue.loading;
    var section = computed(function () {
      var _sectionResult$value;
      return ((_sectionResult$value = sectionResult.value) === null || _sectionResult$value === void 0 ? void 0 : _sectionResult$value.getSection) || [{
        ixId: '',
        templateTexts: [{
          text: ''
        }]
      }];
    });
    return {
      __sfc: true,
      props: props,
      route: route,
      result: result,
      fund: fund,
      sectionResult: sectionResult,
      getSectionLoading: getSectionLoading,
      section: section,
      ReportType: ReportType
    };
  }
});